<template>
    <div class="favorite-page-container">
       <!-- СТРАНИЦА - {{ cardID }} -->
       <favoriteEmptyMsg :emptyMsgArr="emptyDescArr" v-if="emptyMsgInit"></favoriteEmptyMsg>
       <favoriteSalesItems :favoriteSalesItems="favoriteItems" v-if="!emptyMsgInit && cardID == 'favoriteSales'"></favoriteSalesItems>
       <favoriteOtherItems :favoriteItems="favoriteItems" v-if="!emptyMsgInit && cardID != 'favoriteSales'"></favoriteOtherItems>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import favoriteEmptyMsg from '@/components/favorite-page/favorite-empty-msg.vue';
    import favoriteSalesItems from '@/components/favorite-page/favorite-sales-items.vue';
    import favoriteOtherItems from '@/components/favorite-page/favorite-other-items.vue';
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'about-page-section',
        components: {
            favoriteEmptyMsg,
            favoriteSalesItems,
            favoriteOtherItems,
            // svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                emptyDescArr: null,
                emptyMsgInit: false,
                favoriteItems: null,
                cardID: this.$route.name,
            }
        },
        computed: mapGetters({
            favoritePage: 'loadFavoritePage',
        }),
        methods: {
            filterEmptyDesc() {
                const emptyDescMap = {
                    'favoriteSales': this.favoritePage.empty_desc_sales,
                    'favoriteFlats': this.favoritePage.empty_desc_flats,
                    'favoriteParking': this.favoritePage.empty_desc_parking,
                    'favoriteStoreRooms': this.favoritePage.empty_desc_storerooms,
                    'favoriteCommerce': this.favoritePage.empty_desc_commerce
                };

                if (emptyDescMap.hasOwnProperty(this.cardID)) {
                    this.emptyDescArr = emptyDescMap[this.cardID];
                } else {
                    return false;
                }
            },  
            getFavoriteItems() {
                this.favoriteItems = null;
                const localStorageKeys = {
                    'favoriteSales': 'favorite_projects_dial',
                    'favoriteFlats': 'favorite_flats_dial',
                    'favoriteParking': 'favorite_parking_dial',
                    'favoriteStoreRooms': 'favorite_storerooms_dial',
                    'favoriteCommerce': 'favorite_commerce_dial'
                };
                const localStorageKey = localStorageKeys[this.cardID];
                if (localStorageKey) {
                    this.favoriteItems = this.getLocalStorageFavorites(localStorageKey);
                    // console.log(this.favoriteItems, `FAVORITES ${this.cardID.toUpperCase()}`);
                }
            },
            getLocalStorageFavorites(key) {
                const favoritesLocal = JSON.parse(localStorage.getItem(key)) || [];
                this.emptyMsgInit = favoritesLocal.length === 0;
                return favoritesLocal;            
            }
        },
        created () {
        },
        mounted() {
            this.getFavoriteItems();
            this.filterEmptyDesc();
            this.$store.watch(
                (state) => state.favoriteLocalStorageUpdate,
                (newValue, oldValue) => {
                    if (newValue || oldValue) {
                        this.getFavoriteItems();
                    } else {
                        this.getFavoriteItems();
                    }
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/favorite-page/favorite-page-container.scss';
    @import '@/styles/components/favorite-page/respond/favorite-page-container-respond.scss';
</style>